import React from 'react';

import JobsListSubPage from '../../../js/pages/JobsListPage/SubPage';
import mlEngineer from '../../../js/pages/JobsListPage/mlEngineerJobs';
import {makeStaticPaths, makeStaticProps} from '../../../js/pages/JobsListPage/staticRoutes';

const Page = ({slug}) => <JobsListSubPage role={mlEngineer} slug={slug} />;

export default Page;

export const getStaticProps = makeStaticProps(mlEngineer);
export const getStaticPaths = makeStaticPaths(mlEngineer);
